import { InputAdornment as MuiInputAdornment, InputAdornmentProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export type { InputAdornmentProps };

export const InputAdornment: React.ComponentType<InputAdornmentProps> = styled(
  MuiInputAdornment,
)<InputAdornmentProps>(({ theme }) => ({
  [`&.MuiInputAdornment-root`]: {
    color: `${theme.palette.colors.content.primary}`,
  },
}));
